import React, {useState, useEffect} from 'react';
import { Button, Spinner } from 'reactstrap';
import { FormikProps } from 'formik';

interface ActionButtonsProps {
    onSubmit: () => void;
    disabled?: boolean;
    loading?: boolean;
    formik: FormikProps<any>;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
    onSubmit,
    disabled = false,
    loading = false,
    formik
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        setIsSubmitting(loading);
    }, [loading]);

    const handleClick = async () => {
        const errors = await formik.validateForm();
        
        if (Object.keys(errors).length > 0) {
            const firstErrorField = Object.keys(errors)[0];
            formik.setFieldTouched(firstErrorField, true, false);
            const fieldElement = document.querySelector(`[name="${firstErrorField}"]`) as HTMLElement;
            if (fieldElement) {
                fieldElement.focus();
            }
            return;
        }
        
        onSubmit();
    };

    return (
        <>
            <div className="d-flex justify-content-end gap-2 mt-4">
                <Button
                    color="success"
                    className="px-4 fw-bold shadow-sm"
                    onClick={handleClick}
                    disabled={disabled || loading}
                >
                    {isSubmitting ? (
                        <>
                            <Spinner size="sm" className="me-2" />
                            Enviando...
                        </>
                    ) : (
                        <>
                            <i className="ri-save-3-line me-1"></i>
                            Generar Guia
                        </>
                    )}
                </Button>
            </div>
        </>
    );
};

export default ActionButtons;
